import styled from 'react-emotion';

import BaseListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import BaseIconButton from '@ublend-npm/aulaui-next-web/IconButton';
import theme from '@ublend-npm/aulaui-next-web/themes/default';

export const ListItemSecondaryAction = styled(BaseListItemSecondaryAction)`
  display: flex;
  position: relative;
  transform: translateY(0%);
  right: auto;
  top: auto;
  margin-left: auto;
`;

export const CircularProgressContainer = styled('div')`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
`;

export const IconButton = styled(BaseIconButton)`
  background-color: transparent;
  color: ${theme.color.designSystem.blackOpacity60};

  :hover {
    background-color: ${theme.color.designSystem.background.grey.hover};
  }
`;
